import axios from "axios";
import { getApiBase } from "../apiBase";
import { buildPluginsHeader } from "./registry";

const AUTH_TOKEN_KEY = "projectBoardAuthToken";

function authHeaders() {
  const h = { ...buildPluginsHeader() };
  try {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) h.Authorization = `Bearer ${token}`;
  } catch {
    /* ignore */
  }
  return h;
}

export async function fetchAdminApiKeys() {
  const { data } = await axios.get(`${getApiBase()}/admin/api-keys`, {
    headers: authHeaders(),
  });
  return Array.isArray(data) ? data : [];
}

export async function postAdminApiKey({ name, expiresAt }) {
  const body = { name };
  if (expiresAt != null && String(expiresAt).trim() !== "") {
    body.expiresAt = expiresAt;
  }
  const { data } = await axios.post(`${getApiBase()}/admin/api-keys`, body, {
    headers: authHeaders(),
  });
  return data;
}

export async function revokeAdminApiKey(id) {
  const { data } = await axios.delete(`${getApiBase()}/admin/api-keys/${id}`, {
    headers: authHeaders(),
  });
  return data;
}
